<!--
 * @Author: 张天昊
 * @Date: 2024-05-17 14:30:43
 * @LastEditTime: 2024-11-05 11:17:41
 * @LastEditors: 张天昊
 * @Description: 二维码按钮
 * @FilePath: /Mobile/src/pages/itineraryUniversal/components/QrCodeLauncher.vue
-->
<script>
import { defineComponent, ref } from 'vue';

export default defineComponent({
  props: {
    value: {
      type: String
    }
  },
  setup() {
    const popupShow = ref(false);
    function onClick() {
      popupShow.value = true;
    }
    function onClose() {
      popupShow.value = false;
    }
    return {
      popupShow,
      onClick,
      onClose
    };
  }
});
</script>

<template>
  <div>
    <div
      class="flex items-center px-8 py-6 text-white bg-green-a rounded-4 van-haptics-feedback"
      @click="onClick"
    >
      <svg-icon
        pre-path="itineraryUniversal"
        name="ic-qrcode"
        class="w-14 h-14"
      ></svg-icon>
      <span class="text-11 leading-14 ml-6">行程码</span>
    </div>
    <van-popup v-model="popupShow" class="custom-popup">
      <div class="flex flex-col items-center w-full py-32 rounded-4 bg-white">
        <div class="text-18 leading-26 font-medium text-black-primary">电子行程单二维码</div>
        <img :src="value" class="block mt-16 w-190 h-190" />
      </div>
      <div
        class="w-48 h-48 mt-24 mx-auto rounded-full bg-black/30 text-0"
        @click="onClose"
      >
        <svg-icon pre-path="itineraryUniversal" name="ic-popup-close" class="w-full h-full"></svg-icon>
      </div>
    </van-popup>
  </div>
</template>

<style scoped>
.custom-popup.van-popup {
  width: 260px;
  background: transparent;
  overflow: hidden;
}
</style>
